var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.8,8.6L5.1,7.1l1.8-1.8L8.5,7c0.3-0.2,0.7-0.5,1-0.7l-1-2.1l2.4-1l0.8,2.2c0.4-0.1,0.8-0.2,1.2-0.2L12.7,3 h2.6l-0.1,2.3c0.4,0.1,0.8,0.1,1.2,0.2l0.8-2.2l2.4,1l-1,2.1c0.3,0.2,0.7,0.4,1,0.7l1.6-1.7l1.8,1.8l-1.8,1.5 c0.2,0.3,0.5,0.6,0.7,1l2.1-1l1,2.3l-2.2,0.8c0.1,0.4,0.2,0.8,0.2,1.1l2.4-0.1v2.5L23,15.1c-0.1,0.4-0.1,0.8-0.2,1.1L25,17l-1,2.3 l-2.1-1c-0.2,0.3-0.4,0.7-0.7,1l1.8,1.5l-1.8,1.8L19.5,21c-0.3,0.2-0.7,0.5-1,0.7l1,2.1l-2.4,1l-0.8-2.2c-0.4,0.1-0.8,0.2-1.2,0.2 l0.1,2.3h-2.6l0.1-2.3c-0.4-0.1-0.8-0.1-1.2-0.2l-0.8,2.2l-2.4-1l1-2.1c-0.3-0.2-0.7-0.4-1-0.7l-1.6,1.7l-1.8-1.8l1.8-1.5 c-0.2-0.3-0.5-0.6-0.7-1l-2.1,1L3,17l2.2-0.8c-0.1-0.4-0.2-0.8-0.2-1.1l-2.4,0.1v-2.5L5,12.9c0.1-0.4,0.1-0.8,0.2-1.1L3,11l1-2.3 l2.1,1C6.4,9.3,6.6,9,6.8,8.6z M8.5,14c0,1.1,0.3,2.1,0.9,3c0.6,0.9,1.4,1.6,2.4,2c1,0.4,2.1,0.5,3.2,0.3c1.1-0.2,2.1-0.7,2.8-1.5 c0.8-0.8,1.3-1.7,1.5-2.8c0.2-1.1,0.1-2.1-0.3-3.1c-0.4-1-1.1-1.8-2-2.4c-0.9-0.6-2-0.9-3.1-0.9c-0.7,0-1.4,0.1-2.1,0.4 c-0.7,0.3-1.3,0.7-1.8,1.2c-0.5,0.5-0.9,1.1-1.2,1.7C8.7,12.6,8.5,13.3,8.5,14z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a93c37b0.svg";
export { ForwardRef as ReactComponent };